import React, { useEffect } from 'react';
import styled from 'styled-components';
import { LifePageSubNavigation } from './lifePageSubNavigation';
import { largeMediaQuery, mediumMediaQuery, smallMediaQuery } from '../../common/utilities/sizeHelpers';
import { LifePageTab } from './lifePageTab';
import { LifeNavModal } from './lifeNavModal';
import ngDeps from '../../common/utilities/ngDependencies';
import { reduxConnect } from '../../common';
import { LifePageIds } from './lifePageTypes';

interface LifePageContentViewProps {
    activePageId: string;
}

const mapStoreStateToProps = (storeState: any) => {
    const { pageId } = storeState?.appState?.appState || {};

    return {
        activePageId: pageId
    };
};

const mapDispatchToProps = {};

export const LifePageContentView = reduxConnect(mapStoreStateToProps, mapDispatchToProps)(({ activePageId }: LifePageContentViewProps) => {

    useEffect(() => {
        return () => {
            ngDeps?.rootScope?.App?.updateBackground?.();
        };
    }, []);

    return (
        <Container>
            <Wrap>
                <LifeNavModal />
                <LifePageSubNavigation />
                <LifeTabContentWrapper isSnowSkiDetail={activePageId?.toLocaleLowerCase() === LifePageIds.snowSkiDetail}>
                    <LifePageTab />
                </LifeTabContentWrapper>
            </Wrap>
        </Container>
    );
});

LifePageContentView.displayName = 'LifePageContentView';

const Container = styled.div`
    display: flex;
    width: 100%;
    @media ${smallMediaQuery} {
        padding-top: 10px;
    }
`;

const Wrap = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    height: auto;
    margin: 0 auto;
    background-size: 100% 531px;
    padding: 0 10px;

    @media ${mediumMediaQuery} {
        padding: 0 15px;
    }

    @media ${largeMediaQuery} {
        flex-direction: row;
        max-width: calc(1218px + 8%);
        padding: 0 4%;
    }
`;

interface LifeTabContentWrapperProps {
    isSnowSkiDetail: boolean;
}

const LifeTabContentWrapper = styled.div<LifeTabContentWrapperProps>`
    display: flex;
    flex-direction: column;
    @media ${largeMediaQuery} {
        padding-left: 16px;
        width: ${({ isSnowSkiDetail }) => isSnowSkiDetail ? '100%' : 'calc(100% - 140px)'};
    }
`;